import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import logger from "./global/logger";
import { Dialog } from "vant";
import { Button } from "vant";
import { Row, Col } from "vant";
import { Icon } from "vant";
import { Cell, CellGroup } from "vant";
import { Form, Field } from "vant";
import { CountDown } from "vant";
import { RadioGroup, Radio } from "vant";
import { Popup } from "vant";
import { NavBar } from "vant";
import { DatePicker } from "vant";
import { Picker } from "vant";
import { Tabbar, TabbarItem } from "vant";
import { Image as VanImage } from "vant";
import { PullRefresh } from "vant";
import { List } from "vant";
import { Card } from "vant";
import { Tag } from "vant";
import { Toast } from "vant";
import { Loading } from "vant";
import { Swipe, SwipeItem } from "vant";
import { Grid, GridItem } from "vant";
import { Collapse, CollapseItem } from "vant";
import "amfe-flexible"; //rem??���Ĺ���
import "vant/es/toast/style";
import wechatUtil from "@/global/WechatUtil.js";
import apiUtil from "@/api/request.js";
import jsUtil from "@/global/jsUtil.js";
import util from "@/global/util.js";
import env from "@/global/env.js";
import axios from "axios";
import "./assets/styles/main.css";
import "vant/lib/index.css";
import "./assets/styles/common.css";

const app = createApp(App);
app.use(store);
app
  .use(router)
  .use(Button)
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Field)
  .use(CountDown)
  .use(RadioGroup)
  .use(Radio)
  .use(NavBar)
  .use(Dialog)
  .use(Popup)
  .use(DatePicker)
  .use(Tabbar)
  .use(Picker)
  .use(TabbarItem)
  .use(PullRefresh)
  .use(VanImage)
  .use(List)
  .use(Card)
  .use(Tag)
  .use(Toast)
  .use(Swipe)
  .use(SwipeItem)
  .use(Grid)
  .use(GridItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Loading);

wechatUtil.ConfigIsWxEnv();

// 添加版本控制和缓存检查
const APP_VERSION = "1.0.0"; // 每次发布更新时手动修改此版本号
const STORAGE_VERSION_KEY = "app_version";

// 检查版本并刷新缓存
if (env.isWxEnv) {
  const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY);
  if (storedVersion !== APP_VERSION) {
    // 版本不一致，清除缓存并存储新版本
    localStorage.setItem(STORAGE_VERSION_KEY, APP_VERSION);
    // 如果是首次加载或版本已更新，添加时间戳参数强制刷新
    if (window.location.href.indexOf("t=") === -1) {
      const timestamp = new Date().getTime();
      const currentUrl = window.location.href;
      const newUrl = currentUrl.includes("?")
        ? `${currentUrl}&t=${timestamp}`
        : `${currentUrl}?t=${timestamp}`;
      window.location.replace(newUrl);
    }
  }
}

app.mount("#app");
